import { useEffect, useState } from "react";
import { BasketItem } from "../../../models/BasketItem";
import { Question } from "../../../models/Question";
import { setSuccessMessage, setWarningMessage } from "../../../store/alerts/alertsActions";
import { useDispatch } from "react-redux";
import { post } from "../../../api";
import { SAVE_BASKET_QUESTIONS } from "../../../api/apiRoutes";
import useFacility from "../../../../utils/hooks/useFacility";

// eslint-disable-next-line import/no-anonymous-default-export
export default (basket: BasketItem[], getBasket: Function) => {
  const [questions, setQuestions] = useState<Question[]>([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const facilityIds = useFacility();

  // Pobiera wszystkie pytania z koszyka
  useEffect(() => {
    const allQuestions = basket.flatMap((item) =>
      (item.questions || [])
        .filter((q) => q.question)
        .map((q) => ({
          ...q,
          assortName: item.assortName,
        }))
    );
    setQuestions(allQuestions);
  }, [basket]);

  const checkQuestionsCompleted = () => {
    return questions.every((q) => q.answer.trim() !== "");
  };

  const setAnswer = (surveyIds: string, question: string, answer: string) => {
    setQuestions((prev) =>
      prev.map((q) => (q.question === question && q.surveyIds === surveyIds ? { ...q, answer } : q))
    );
  };

  const handleProceed = () => {
    if (!checkQuestionsCompleted()) {
      setIsModalOpen(true);
      return false;
    }
    return true;
  };

  const onSaveAnswers = async () => {
    setLoading(true);
    const updatedBasket = basket.map((item) => ({
      ...item,
      questions: item.questions.map((q) => ({
        ...q,
        answer: questions.find((updatedQ) => updatedQ.surveyIds === q.surveyIds)?.answer || "",
      })),
    }));

    const { isError, errorTable } = await post(SAVE_BASKET_QUESTIONS(facilityIds), { basket: updatedBasket });
    if (!isError) {
      dispatch(setSuccessMessage("Zapisano odpowiedzi na pytania"));
    } else {
      dispatch(setWarningMessage([errorTable]));
    }
    setIsModalOpen(false);
    getBasket();
    setLoading(false);
  };

  return {
    questions,
    isModalOpen,
    setIsModalOpen,
    setAnswer,
    handleProceed,
    onSaveAnswers,
    loading,
  };
};
